import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { seoConfig } from '../config/seoKeywords';

/**
 * Component to dynamically update Meta Tags and Title for SEO/AEO
 * This ensures search engines see the updated keywords from seoKeywords.js
 */
const SEOHead = ({ title, description }) => {
  const { lang } = useLanguage();
  const config = seoConfig[lang] || seoConfig.ro;

  useEffect(() => {
    // Update Document Title
    document.title = title || config.title;

    // Update Meta Description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || config.defaultDescription);
    }

    // Update Meta Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', config.keywords.join(', '));
    }

    // Dynamic JSON-LD for AEO (Structured Data)
    const scriptId = 'aeo-structured-data';
    let script = document.getElementById(scriptId);
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": config.aeoQuestions.map(item => ({
        "@type": "Question",
        "name": item.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.a
        }
      }))
    };

    script.text = JSON.stringify(faqSchema);

  }, [lang, title, description, config]);

  return null; // This component doesn't render anything visually
};

export default SEOHead;